import React, { Component } from 'react';
import { withStyles, Stepper, Step, StepLabel, Button, Typography, TextField, Select, FormControl, InputLabel, MenuItem, Radio, RadioGroup, FormControlLabel, FormLabel } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { IWall } from '../../core/models/wall';
import { ADD_WALL, UPDATE_WALL } from '../../core/handlers.actions';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { User } from '../../core/models/user';

const styles = (theme: any) => ({
    root: {
        width: '100%',
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '100%'
        },
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: '100%'
        }
    },
    backButton: { marginRight: theme.spacing(1) },
    cancelButton: { marginLeft: theme.spacing(1) },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        color: 'green'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: { marginTop: theme.spacing(2) },
    reviewContainer: { padding: theme.spacing(2) },
    bottomActions: { marginTop: theme.spacing(4) }
});

interface Props {
    classes: any;
    dismiss: () => void;
    add: (wall: IWall) => void;
    updateWall: (wall: IWall) => void;
    user: User;
    editWall: IWall | null;
    tags: any;
    alerts: any;
}

interface State {
    activeStep: number;
    steps: any;
    wall: any;
}

class WallStepper extends Component<Props, State> {
    state: State = {
        activeStep: 0,
        steps: ['Wall details', 'Wall Tags', 'Post Rules', 'Social Settings', 'Review and save'],
        wall: this.props.editWall || {
            name: '',
            title: '',
            subTitle: '',
            description: '',
            wallTags: [],
            wallTagsRef: [],
            categories: [],
            featuredPosts: [],
            postFeaturedTag: {name: ''},
            layout: 'bricks',
            postRequiresUserInfo: 'No',
            requiresApproval: false,
            displayPostFeaturedTags: false,
            displayPostUserDetails: false,
            feedTags: [],
            feedTagsRef: [],
            userId: this.props.user.id,
            socialButtons: false,
            facebookTitle: '',
            facebookDescription: '',
            twitterTitle: '',
            twitterDescription: '', 
            postRequiresUserFullAddress: false,
            postAfterSaveActionWidget: false
        }
    }

    constructor(props: Props) {
        super(props);
        this.getStepContent = this.getStepContent.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.wallFeedTagChangeHandler = this.wallFeedTagChangeHandler.bind(this);
        this.inputHandleChange = this.inputHandleChange.bind(this);
        this.wallTagChangeHandler = this.wallTagChangeHandler.bind(this);
        this.featuredPostTagOnchangeHandler = this.featuredPostTagOnchangeHandler.bind(this);
        this.wallAlertChangeHandler = this.wallAlertChangeHandler.bind(this);
    }

    public handleNext() {
        const { add, editWall, updateWall } = this.props;
        const { activeStep, steps, wall } = this.state;
        if (activeStep === steps.length - 1) {
            (!editWall) ? add(wall) : updateWall(wall);
        }
        return this.setState({ ...this.state, activeStep: this.state.activeStep + 1 });
    }

    public handleBack() {
        return this.setState({ ...this.state, activeStep: this.state.activeStep - 1 });
    }

    public handleReset() {
        const defaultWall: any = {
            name: '',
            title: '',
            subTitle: '',
            description: '',
            wallTags: [],
            wallTagsRef: [],
            categories: [],
            featuredPosts: [],
            layout: 'bricks',
            postRequiresUserInfo: 'No',
            requiresApproval: false,
            displayPostFeaturedTags: false,
            displayPostUserDetails: false,
            feedTags: [],
            feedTagsRef: [], 
            socialButtons: false,
            facebookTitle: '',
            facebookDescription: '',
            twitterTitle: '',
            twitterDescription: ''
        }
        return this.setState({ ...this.state, activeStep: 0, wall: defaultWall });
    }

    public wallFeedTagChangeHandler(event:any, value:any) {
        const { wall } = this.state;
        wall.feedTagsRef = value;
        this.setState({ ...this.state, wall: wall });
    }

    public inputHandleChange(event: any) {
        const { wall } = this.state;
        
        switch(event.target.name){
            case 'postRequiresApproval':
                wall[event.target.name] = event.target.value === 'Yes' ? true : false;
                return this.setState({ ...this.state, wall: wall });
            
            case 'displayPostFeaturedTags':
                wall[event.target.name] = event.target.value === 'true' ? true: false;
                return this.setState({ ...this.state, wall: wall });

            case 'displayPostUserDetails':
                wall[event.target.name] = event.target.value === 'true'? true: false;
                return this.setState({...this.state, wall:wall});

            case 'socialButtons':
                wall[event.target.name] = event.target.value === 'Yes'? true: false;
                return this.setState({...this.state, wall: wall});
            
            case 'facebookTitle':                
                wall[event.target.name] = event.target.value;
                return this.setState({...this.state, wall: wall});

            case 'facebookDescription':
                wall[event.target.name] = event.target.value;
                return this.setState({...this.state, wall: wall});

            case 'twitterTitle':
                wall[event.target.name] = event.target.value;
                return this.setState({...this.state, wall: wall});

            case 'twitterDescription':
                wall[event.target.name] = event.target.value;
                return this.setState({...this.state, wall: wall});

            case 'postRequiresUserFullAddress':
                wall[event.target.name] = event.target.value === 'Yes'? true: false;
                return this.setState({...this.state, wall:wall});

            default:
                wall[event.target.name] = event.target.value;
                return this.setState({ ...this.state, wall: wall });
        }
    }

    public wallTagChangeHandler(event:any, value:any){
        const { wall } = this.state;
        wall.wallTagsRef = value;
        this.setState({...this.state, wall: wall});     
    }

    public wallAlertChangeHandler(event:any, value:any) {
        const {wall} = this.state;
        wall.alert = value;
        this.setState({...this.state, wall:wall});
    }

    public featuredPostTagOnchangeHandler(event:any, value:any){
        const {wall} = this.state;
        wall.postFeaturedTag = value;        
        this.setState({...this.state, wall: wall});
    }

    public getStepContent(stepIndex: number) {
        const { classes, tags, alerts } = this.props;
        const { wall } = this.state;        
        switch (stepIndex) {
            case 0:
                return (
                    <form noValidate autoComplete="off">
                        <div>
                            <TextField value={wall.name} type="text" required id="name" label="Name" name="name" onChange={this.inputHandleChange} />
                            <TextField value={wall.title} type="text" required id="title" label="Title" name="title" onChange={this.inputHandleChange} />
                            <TextField value={wall.subTitle} type="text" id="subTitle" label="Sub Title" name="subTitle" onChange={this.inputHandleChange} />
                            <TextField value={wall.description} type="text" id="description" label="Description" name="description" multiline rowsMax={15} onChange={this.inputHandleChange} />
                            <FormControl className={classes.formControl}>
                                <InputLabel id="demo-simple-select-label">Wall Layout</InputLabel>
                                <Select
                                    value={wall.layout}
                                    labelId="demo-simple-select-label"
                                    id="layout"
                                    name="layout"
                                    onChange={this.inputHandleChange}>
                                    <MenuItem value="bricks">Bricks</MenuItem>
                                    <MenuItem value="rows">Rows</MenuItem>
                                </Select>
                            </FormControl>                                
                        </div>
                    </form>
                );
            case 1:
                return (
                    <form noValidate autoComplete="off">
                        <div>
                            <Autocomplete
                                multiple={false}
                                id="featured-tag"
                                options={tags}
                                getOptionLabel={(option:any) => option.name}
                                onChange={this.featuredPostTagOnchangeHandler}
                                value={wall.postFeaturedTag}
                                renderInput={(params) => (<TextField {...params} variant="standard" label="Feature post tag" placeholder="Tag"/>)}
                            />

                            <Autocomplete
                                multiple
                                id="wall-tags"
                                options={tags}
                                getOptionLabel={(option:any) => option.name}
                                onChange={this.wallTagChangeHandler}
                                value={wall.wallTagsRef}
                                renderInput={(params) => (<TextField {...params} variant="standard" label="Wall Tags" placeholder="Tag"/>)}
                            />

                            <Autocomplete
                                multiple
                                id="wall-feed-tags"
                                options={tags}
                                getOptionLabel={(option:any) => option.name}
                                onChange={this.wallFeedTagChangeHandler}
                                value={wall.feedTagsRef}
                                renderInput={(params) => (<TextField {...params} variant="standard" label="Wall Feed Tags" placeholder="Tag"/>)}
                            />                        
                            
                            <Autocomplete
                                multiple={false}
                                id="wall-alerts"
                                options={alerts}
                                getOptionLabel={(option:any) => option.name}
                                onChange={this.wallAlertChangeHandler}
                                value={wall.alert}
                                renderInput={(params) => (<TextField {...params} variant="standard" label="Alert" placeholder="Alert"/>)}
                            /> 

                            <FormControl component="fieldset">
                                    <FormLabel component="legend">Display Posts Feature Tag?</FormLabel>
                                    <RadioGroup row value={wall.displayPostFeaturedTags ? 'true' : 'false'} aria-label="displayPostFeaturedTags" name="displayPostFeaturedTags" onChange={this.inputHandleChange}>
                                        <FormControlLabel value="true" control={<Radio color="primary" />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio color="primary" />} label="No" />
                                    </RadioGroup>
                            </FormControl>    
                        </div>
                    </form>
                );
            case 2:
                return (
                    <form noValidate autoComplete="off">
                        <div>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Requires User Info?</FormLabel>
                                <RadioGroup row value={wall.postRequiresUserInfo} aria-label="postRequiresUserInfo" name="postRequiresUserInfo" onChange={this.inputHandleChange}>
                                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                    <FormControlLabel value="No" control={<Radio />} label="No" />
                                    <FormControlLabel value="Optional" control={<Radio />} label="Optional" />
                                </RadioGroup>
                            </FormControl>

                            <FormControl component="fieldset">
                                <FormLabel component="legend">Requires User Full Address?</FormLabel>
                                <RadioGroup row value={wall.postRequiresUserFullAddress? 'Yes': 'No'} aria-label="postRequiresUserFullAddress" name="postRequiresUserFullAddress" onChange={this.inputHandleChange}>
                                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                    <FormControlLabel value="No" control={<Radio />} label="No" />
                                </RadioGroup>
                            </FormControl>

                            <FormControl component="fieldset">
                                <FormLabel component="legend">Display User Info?</FormLabel>
                                <RadioGroup row value={wall.displayPostUserDetails ? 'true' : 'false'} aria-label="displayPostUserDetails" name="displayPostUserDetails" onChange={this.inputHandleChange}>
                                    <FormControlLabel value="true" control={<Radio color="primary" />} label="Yes" />
                                    <FormControlLabel value="false" control={<Radio color="primary" />} label="No" />
                                </RadioGroup>
                            </FormControl>     

                            <FormControl component="fieldset">
                                <FormLabel component="legend">Posts Approval Required?</FormLabel>
                                <RadioGroup row value={wall.postRequiresApproval ? 'Yes' : 'No'} aria-label="postRequiresApproval" name="postRequiresApproval" onChange={this.inputHandleChange}>
                                    <FormControlLabel value="Yes" control={<Radio color="primary" />} label="Yes" />
                                    <FormControlLabel value="No" control={<Radio color="primary" />} label="No" />
                                </RadioGroup>
                            </FormControl>                                          
                        </div>
                    </form>
                );
            case 3:
                return (
                    <form noValidate autoComplete="off">
                        <div>   
                            <TextField value={ wall.facebookTitle || ''} type="text"  label="Facebook Title" name="facebookTitle" onChange={this.inputHandleChange} />
                            <TextField value={ wall.facebookDescription || ''} type="text"  label="Facebook Description" name="facebookDescription" onChange={this.inputHandleChange} />
                            <TextField value={ wall.twitterTitle || ''} type="text"  label="Twitter Title" name="twitterTitle" onChange={this.inputHandleChange} />
                            <TextField value={ wall.twitterDescription || ''} type="text"  label="Twitter Description" name="twitterDescription" onChange={this.inputHandleChange} />
                                  
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Display social buttons?</FormLabel>
                                <RadioGroup row value={wall.socialButtons ? 'Yes' : 'No'} aria-label="socialButtons" name="socialButtons" onChange={this.inputHandleChange}>
                                    <FormControlLabel value="Yes" control={<Radio color="primary" />} label="Yes" />
                                    <FormControlLabel value="No" control={<Radio color="primary" />} label="No" />
                                </RadioGroup>
                            </FormControl>                        
                        </div>
                    </form>
                );
            case 4:
                return (
                    <div className={classes.reviewContainer}>
                            <h2>Are you sure you want to save the wall?</h2>
                    </div>
                );
        }
    }

    public render() {
        const { classes, dismiss, editWall } = this.props;
        const { activeStep, steps } = this.state;
        return (
            <div className={classes.root}>
                <Typography variant="h6" component="h2">{editWall ? 'Edit' : null}</Typography>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label: string, key: number) => (<Step key={key}><StepLabel>{label}</StepLabel></Step>))}
                </Stepper>
                <div>
                    {activeStep === steps.length ?
                        (<div>
                            {editWall ? (<Typography className={classes.instructions}>Wall updated successfully</Typography>) : (<Typography className={classes.instructions}>Wall created successfully</Typography>)}
                            <Button onClick={this.handleReset} color="primary" >Add wall</Button>
                            <Button onClick={dismiss} color="secondary" >Done</Button>
                        </div>)
                        :
                        (<div>
                            {this.getStepContent(activeStep)}
                            <div className={classes.bottomActions}>
                                <Button
                                    disabled={activeStep === 0}
                                    onClick={this.handleBack}
                                    className={classes.backButton}>
                                    Back
                                        </Button>
                                <Button variant="contained" color="primary" onClick={this.handleNext}>
                                    {activeStep === steps.length - 1 ? 'Finish & Save' : 'Next'}
                                </Button>
                                <Button variant="contained" color="secondary" className={classes.cancelButton} onClick={dismiss}>Cancel</Button>
                            </div>
                        </div>)
                    }
                </div>
            </div>
        );
    }
}
const mapProps = (app: any) => ({ user: app.rootReducer.user, tags: app.rootReducer.tags, alerts: app.rootReducer.alerts });
const mapDispatch = ((dispatch: Dispatch) => ({
    add: (wall: IWall) => dispatch({ type: ADD_WALL, payload: wall }),
    updateWall: (wall: IWall) => dispatch({ type: UPDATE_WALL, payload: wall })
}));
export default connect(mapProps, mapDispatch)(withStyles(styles)(WallStepper));